import { render, staticRenderFns } from "./archived-mailings-stats-detailed-table.vue?vue&type=template&id=5431ddbc&"
import script from "./archived-mailings-stats-detailed-table.vue?vue&type=script&lang=js&"
export * from "./archived-mailings-stats-detailed-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports